import { fetchJSON } from '@bonnet/next/fetch';

export default (data) => fetchJSON('/cars-for-sale/svc/leads/email/friend', {
    body: data,
    method: 'POST',
});
